module.exports = __webpack_public_path__ + "static/media/Tac.d104bbaa.png";